
function LogoutButton({ handleLogOut }) {
  
    return (
      <button className="nav--button dark--title" onClick={handleLogOut}>
        <img src="/login.svg" alt="Logout" />
        <div>
          <b>Logout</b>
        </div>
      </button>
    )
  }
  
  export default LogoutButton;